import { REPORT_TYPE_IDS } from "../../../store/constants";
import AnnualDataQuality from "./AnnualDataQuality";

const AnnualServiceComplexity = () => (
  <AnnualDataQuality
    reportTypeId={REPORT_TYPE_IDS.annual_service_performance_complexity}
    title="Annual Department/Service Performance and Complexity"
    description="Annual service complexity view for demand share, workload, variance, waits, outcomes, and SLA confidence."
    emptyDataMessage="Annual Service Complexity data is empty for the selected year."
    searchPrompt="Update filters and hit Search to retrieve annual Service Complexity data."
  />
);

export default AnnualServiceComplexity;
